var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5183983,19.4178932 L6.70101013,28.2352814 L13,28.2352814 L13,32.2352814 L2.64677169e-13,32.2352814 L2.64677169e-13,28.2352814 L2.64677169e-13,19.2352814 L4,19.2352814 L4,25.2794373 L12.6899712,16.5894661 L15.5183983,19.4178932 Z",
    id: "Combined-Shape",
    fill: "#2A2441",
    fillRule: "nonzero",
    transform: "translate(7.759199, 24.412374) rotate(-180.000000) translate(-7.759199, -24.412374) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0183983,2.82842712 L23.2010101,11.6458153 L29.5,11.6458153 L29.5,15.6458153 L16.5,15.6458153 L16.5,11.6458153 L16.5,2.64581528 L20.5,2.64581528 L20.5,8.68997116 L29.1899712,8.08242362e-14 L32.0183983,2.82842712 Z",
    id: "Combined-Shape-Copy",
    fill: "#2A2441",
    fillRule: "nonzero",
    transform: "translate(24.259199, 7.822908) rotate(-360.000000) translate(-24.259199, -7.822908) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.4cd4e196fa29e81abe55aac96d67fa95.svg";
export { ForwardRef as ReactComponent };